import { createFileRoute } from "@tanstack/react-router";
import SeoEcommerceCiudad, { citiesData } from "@/pages/servicios/SeoEcommerceCiudad";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

export const Route = createFileRoute("/servicios/seo-ecommerce/$ciudad")({
  component: SeoEcommerceCiudad,
  head: ({ params }) => {
    const ciudadLower = params.ciudad?.toLowerCase();
    const cityData = ciudadLower ? citiesData[ciudadLower] : null;

    if (!cityData) {
      return {
        meta: [
          { title: "Ciudad no disponible | SEOEVOLUTION" },
          { name: "robots", content: "noindex" },
        ],
      };
    }

    const title = `Agencia SEO Ecommerce en ${cityData.name} | SEOEVOLUTION`;
    const description = `Agencia SEO eCommerce premium en ${cityData.name}. Aumentamos las ventas de tu tienda online con estrategias SEO especializadas para Shopify, PrestaShop y WooCommerce en ${cityData.province}.`;
    const canonicalUrl = `https://agenciaseoevolution.com/servicios/seo-ecommerce/${ciudadLower}`;

    const schema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": `SEOEVOLUTION - SEO eCommerce ${cityData.name}`,
      "description": `Servicios especializados de SEO para tiendas online en ${cityData.name}`,
      "areaServed": {
        "@type": "City",
        "name": cityData.name,
        "containedIn": {
          "@type": "AdministrativeArea",
          "name": cityData.province
        }
      },
      "url": canonicalUrl,
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Servicios SEO eCommerce",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Optimización Fichas de Producto",
              "description": "Mejora el SEO de tus productos para aumentar ventas"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Estructura de Categorías SEO",
              "description": "Arquitectura web optimizada para eCommerce"
            }
          }
        ]
      }
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "keywords", content: cityData.keywords.join(', ') },
        { property: "og:type", content: "website" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: canonicalUrl },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [
        { rel: "canonical", href: canonicalUrl },
      ],
      scripts: [
        ldJson(
          buildBreadcrumb([
            { name: "SEO Ecommerce con IA", path: "/servicios/seo-ecommerce-ia" },
            { name: cityData.name, path: `/servicios/seo-ecommerce/${ciudadLower}` },
          ]),
        ),
        { type: "application/ld+json", children: JSON.stringify(schema) },
      ],
    };
  },
});
